import Vue from 'vue';
import basketcounter from "../components/basketcounter.vue";
import toastmessage from "../components/toastmessage.vue";
import UserLocalization from "../components/UserLocalization.vue";
import comparedropdown from "../components/comparedropdown.vue";
document.addEventListener("DOMContentLoaded", function ()
{

    if (document.getElementById('headerMain')) {
        const InitHeader = {
            props: {
                api: {
                    type: String,
                },
                userId: {
                    type: Number,
                }
            },
            render() {
                return this.$slots.default
            },
            mounted() {
                this.$root.api = this.api;
                this.$root.userId = this.userId;
            }
        }
        new Vue({
            name: 'HeaderElement',
            el: '#headerMain',
            components: {
                InitHeader,
                basketcounter,
                UserLocalization,
                comparedropdown,
                toastmessage
            },
            data: () => ({
                popupCompareShow: false,
                searchInputOpen: false,
                isLoading: false,
                search: '',
                delayTimer: undefined,
                suggestions: [],
                medias: [],
                products: [],
                categories: [],
                userId: undefined,
                searchLink: undefined,
                showBackdrop: false,
                productsLeft: [],
                productsRight: [],
                logoutModalIsOpen: false,
                total: {
                    medias: '',
                    products: '',
                },
                popupOpen: false
            }),
            watch: {
                search(value) {
                    if (value.length === 0) {
                        this.closePopup();
                    } else if (value.length >= 2) {
                        this.handleSearch();
                    }
                }
            },
            computed: {
                generatedSearchLink() {
                    return this.searchLink;
                }
            },
            methods: {
                activatePopup(){
                    let self = this;
                    self.popupCompareShow = true;
                    window.setTimeout(function() {
                        self.popupCompareShow = false;
                    },4000);
                },
                focusInput(){
                    let self = this;
                    this.$nextTick(() => self.$refs.searchfield.focus())
                    //self.$refs.searchfield.$el.focus();
                },
                openLogoutModal() {
                    this.showBackdrop = true;
                    this.logoutModalIsOpen = true;
                },
                closeLogoutModal() {
                    this.showBackdrop = false;
                    this.logoutModalIsOpen = false;
                },
                handleSearch() {
                    clearTimeout(this.delayTimer);
                    this.delayTimer = setTimeout(() => {
                        if (this.search.length === 0) {
                            this.closePopup()
                            return;
                        }

                        this.showPopup()
                        this.isLoading = true;
                        $.ajax({
                            type: "GET",
                            url: this.api,
                            data: {
                                search: this.search
                            },
                            dataType: 'JSON',
                            success: (resp) => {
                                // this.suggestions = resp.suggestions;
                                // this.medias = resp.medias ? resp.medias.slice(0,5) : [];
                                this.productsLeft = resp.products ? resp.products.splice(0, 5) : [];
                                this.productsRight = resp.products ? resp.products.slice(0, 5) : [];

                                this.searchLink = resp.searchResultLink;
                                if (this.products.length) {
                                    this.showPopup()
                                }

                                // this.total.medias = resp.mediasTotal;
                                this.total.products = resp.productsTotal;
                                this.categories = resp.categories ? resp.categories.slice(0, 5) : [];
                                this.isLoading = false;
                            }
                        });
                    }, 500);
                },
                showPopup() {
                    this.popupOpen = true;
                    $('.content__header').addClass('search-focused');
                    $('body').addClass('search--results-opened');
                    // if($('body').hasClass('mm--state-opened')) {
                    //     $('#toggleResponsive').prop('checked', false).change();
                    // }

                },
                closePopup() {
                    if (this.popupOpen) {
                        $('.content__header').removeClass('search-focused');
                        $('body').removeClass('search--results-opened');
                        this.popupOpen = false;
                        this.isLoading = false;
                    }
                },
                changeCountry({country, languageLink})
                {
                    var xhttp = new XMLHttpRequest();
                    xhttp.open('GET', '/app/de/currency/set?country=' + country, false);
                    // xhttp.setRequestHeader('Content-Type', 'application/json');
                    xhttp.setRequestHeader('X-CSRF-Token', document.querySelector('meta[name="csrf-token"]').content);
                    xhttp.onreadystatechange = function () {
                        if (this.readyState == 4 && this.status == 200) {
                            // Response
                            var response = this.responseText;
                            console.log(this.response)
                            if (languageLink) {
                                window.location.href = languageLink;
                            } else {
                                location.reload();
                            }
                        }
                    };
                    xhttp.send();
                }
            },
        });
    }

});